import { combineReducers } from '@reduxjs/toolkit';
import { releaseNotesReducer } from './reducers/release-notes-reducer';
import { latestVersionReducer } from './reducers/latest-version-reducer';
import type { IReleaseNotesModuleState } from './interfaces';


export default combineReducers<IReleaseNotesModuleState>({
  releaseNotesReducer,
  latestVersionReducer
});